"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReflectionOfTessalynAbilityHandler = exports.ReflectionOfTessalynActorAbilityFactory = exports.ReflectionOfTessalynAbilityArgs = void 0;
const __1 = require("../..");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const DamageReflect_1 = require("../../core/effects/core/DamageReflect");
const Regeneration_1 = require("../../core/effects/core/Regeneration");
const Registries_1 = require("../../core/state/Registries");
class ReflectionOfTessalynAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ReflectionOfTessalyn;
        this.__typeName = "ReflectionOfTessalyn";
    }
}
exports.ReflectionOfTessalynAbilityArgs = ReflectionOfTessalynAbilityArgs;
let ReflectionOfTessalynActorAbilityFactory = class ReflectionOfTessalynActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ReflectionOfTessalyn", "Self", 4);
    }
};
ReflectionOfTessalynActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ReflectionOfTessalyn")
], ReflectionOfTessalynActorAbilityFactory);
exports.ReflectionOfTessalynActorAbilityFactory = ReflectionOfTessalynActorAbilityFactory;
let ReflectionOfTessalynAbilityHandler = class ReflectionOfTessalynAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyBuff({
            sequence,
            creatorId: ability.invokerId,
            targetId: ability.invokerId,
            effect: new __1.LinkedEffectsEffectArgs([
                new DamageReflect_1.DamageReflectEffectArgs(5),
                new Regeneration_1.RegenerationEffectArgs("ReflectionOfTessalyn", container.getPercentOfBaseHealth(ability.invokerId, 2)),
            ], false),
            duration: Duration_1.Duration.Turns(4),
            onApplied: (sequence) => {
                sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(ability.invokerId, "chest"), "MagicBubble"));
            }
        });
    }
};
ReflectionOfTessalynAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ReflectionOfTessalyn)
], ReflectionOfTessalynAbilityHandler);
exports.ReflectionOfTessalynAbilityHandler = ReflectionOfTessalynAbilityHandler;
